import { useIntl } from "react-intl";

import { useCohort } from "@/components/user-context/helpers/cohorts";

import { SignupDefault } from "../../../components/signup-default";
import { LoggedInBlueWaveTemplateJsmExistingUser } from "../../components/blue-wave-template-jam-existing-user";
import { LoggedInBlueWaveTemplateJsmNewUser } from "../../components/blue-wave-template-jsm-new-user";

export const LoggedInJsmStandard = () => {
    const { formatMessage } = useIntl();
    const cohort = useCohort();

    if (cohort === "new-user") {
        return (
            <LoggedInBlueWaveTemplateJsmNewUser
                productEditionText={formatMessage({
                    id: "WacSignupHeader.cloudStandard",
                    defaultMessage: "Cloud Standard"
                })}
            />
        );
    }

    if (cohort) {
        return (
            <LoggedInBlueWaveTemplateJsmExistingUser
                productEditionText={formatMessage({
                    id: "WacSignupHeader.cloudStandard",
                    defaultMessage: "Cloud Standard"
                })}
            />
        );
    }

    if (cohort) {
        // bxpkit catch-all leaving in for possible restart of experiment: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/signup_trialing_add_payment_ab/results can remove ~July 18th
        return <SignupDefault />;
    }

    return null;
};
